import {
  addApplicationNumber,
  getApplicationUploadFile,
  getIdExists,
  getUploadFile,
  searchCategoryDetail,
  parseBibData,
} from "JS/API";
import { useEffect, useRef, useState } from "react";
import {
  FaFileAlt,
  FaTrash,
  FaImage,
  FaUser,
  FaTags,
  FaListAlt,
  FaCalendarAlt,
  FaCheck,
  FaTimes,
  FaReceipt,
  FaSave,
  FaUpload,
  FaSearch,
  FaChevronDown,
  FaChevronUp,
  FaChevronRight,
  FaChevronLeft,
} from "react-icons/fa";
import { IoCloseOutline } from "react-icons/io5";
import { FaImages } from "react-icons/fa";
import { FiPlusCircle } from "react-icons/fi";

const ApplicationForm = ({
  setEnterFloatSideBar,
  pkUserId,
  getList,
  alreadyApplicantName,
  customerNumber,
  markNameArr,
}) => {
  // State declarations
  const [originalFileName, setOriginalFileName] = useState("");
  const [fileName, setFileName] = useState("");
  const [img, setImg] = useState("");
  const [, setFile] = useState("");
  const [uploadImg, setUploadImg] = useState("");
  const [, setUploadComplete] = useState(false);
  const [imagePath, setImagePath] = useState("");
  const [applicationType, setApplicationType] = useState("");
  const [applicationStatus, setApplicationStatus] = useState('');
  const [priorityReview, setPriorityReveiw] = useState('');
  const [applicationNumber, setApplicationNumber] = useState("");
  const [userId, setUserId] = useState("");
  const [applicationDate, setApplicationDate] = useState("");
  const [applicantName, setApplicantName] = useState("");
  const [markName, setMarkName] = useState("");
  const [patentCustomerNumber, setPatentCustomerNumber] = useState("");
  const [idExists, setIdExists] = useState(null);
  const [idChecked, setIdChecked] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [categoryData, setCategoryData] = useState([]);
  const [openGroups, setOpenGroups] = useState({});
  const [offsets, setOffsets] = useState({});
  const [hasMore, setHasMore] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [focusedProductIndex, setFocusedProductIndex] = useState(-1);
  const [isOpen, setIsOpen] = useState(true);

  const [productList, setProductList] = useState([{ category: "", items: "" }]);

  // File refs
  const fileInputRef = useRef(null);
  const bibFileInputRef = useRef(null);
  const fileRefApplication = useRef(null);
  const fileRefPower = useRef(null);
  const fileRefSeal = useRef(null);
  const resultWrapRef = useRef();

  // File names
  const [fileNameApplication, setFileNameApplication] = useState("");
  const [fileNamePower, setFileNamePower] = useState("");
  const [fileNameSeal, setFileNameSeal] = useState("");

  const limit = 5;

  // 상수 정의
  const applicationTypes = [
    { value: "NORMAL", label: "일반출원" },
    { value: "SEARCH", label: "조사출원" },
    { value: "FAST", label: "신속출원" },
    { value: "FASTSEARCH", label: "신속조사출원" }
  ];

  const applicationStatuses = [
    { value: "출원 전", label: "출원 전" },
    { value: "출원", label: "출원" }
  ];

  const priorityOptions = [
    { value: "Y", label: "Y" },
    { value: "N", label: "N" }
  ];

  // 스타일 정의
  const styles = {
    container: {
      position: "fixed",
      right: "0",
      bottom: "0",
      height: "100vh",
      backgroundColor: "#ffffff",
      zIndex: 9999,
      display: "flex",
      boxShadow: "-4px 0 20px rgba(0, 0, 0, 0.15)",
      border: "1px solid #e2e8f0"
    },
    leftSection: {
      width: "400px",
      backgroundColor: "#f8fafc",
      borderRight: "1px solid #e2e8f0",
      display: "flex",
      flexDirection: "column"
    },
    rightSection: {
      width: "450px",
      backgroundColor: "#ffffff",
      display: "flex",
      flexDirection: "column"
    },
    sectionHeader: {
      padding: "16px 20px",
      backgroundColor: "#1e293b",
      color: "#ffffff",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      fontSize: "16px",
      fontWeight: "600"
    },
    headerButton: {
      background: "none",
      border: "none",
      color: "#ffffff",
      cursor: "pointer",
      padding: "4px",
      borderRadius: "4px",
      transition: "background-color 0.2s ease"
    },
    content: {
      flex: 1,
      overflow: "auto",
      padding: "20px"
    },
    inputGroup: {
      marginBottom: "16px"
    },
    label: {
      display: "block",
      marginBottom: "6px",
      fontSize: "14px",
      fontWeight: "600",
      color: "#374151"
    },
    input: {
      width: "100%",
      padding: "10px 12px",
      border: "1px solid #d1d5db",
      borderRadius: "8px",
      fontSize: "14px",
      backgroundColor: "#ffffff",
      transition: "border-color 0.2s ease, box-shadow 0.2s ease",
      boxSizing: "border-box"
    },
    inputFocus: {
      borderColor: "#3b82f6",
      boxShadow: "0 0 0 3px rgba(59, 130, 246, 0.1)"
    },
    select: {
      width: "100%",
      padding: "10px 12px",
      border: "1px solid #d1d5db",
      borderRadius: "8px",
      fontSize: "14px",
      backgroundColor: "#ffffff",
      transition: "border-color 0.2s ease",
      boxSizing: "border-box"
    },
    textarea: {
      width: "100%",
      minHeight: "80px",
      padding: "10px 12px",
      border: "1px solid #d1d5db",
      borderRadius: "8px",
      fontSize: "14px",
      backgroundColor: "#ffffff",
      resize: "vertical",
      fontFamily: "inherit",
      transition: "border-color 0.2s ease",
      boxSizing: "border-box"
    },
    button: {
      display: "flex",
      alignItems: "center",
      gap: "8px",
      padding: "10px 16px",
      backgroundColor: "#3b82f6",
      color: "#ffffff",
      border: "none",
      borderRadius: "8px",
      fontSize: "14px",
      fontWeight: "500",
      cursor: "pointer",
      transition: "background-color 0.2s ease"
    },
    buttonSecondary: {
      backgroundColor: "#6b7280",
      color: "#ffffff"
    },
    buttonDanger: {
      backgroundColor: "#dc2626",
      color: "#ffffff"
    },
    buttonSuccess: {
      backgroundColor: "#059669",
      color: "#ffffff"
    },
    buttonSmall: {
      padding: "6px 12px",
      fontSize: "12px"
    },
    imageUpload: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      border: "2px dashed #cbd5e1",
      borderRadius: "12px",
      width: "100%",
      marginBottom: "16px",
      backgroundColor: "#f8fafc",
      height: "200px",
      cursor: "pointer",
      transition: "all 0.2s ease"
    },
    imageUploadHover: {
      borderColor: "#3b82f6",
      backgroundColor: "#eff6ff"
    },
    uploadedImage: {
      maxHeight: "180px",
      maxWidth: "100%",
      borderRadius: "8px"
    },
    searchSection: {
      padding: "16px",
      borderBottom: "1px solid #e2e8f0"
    },
    searchInput: {
      flex: 1,
      padding: "8px 12px",
      border: "1px solid #d1d5db",
      borderRadius: "6px",
      fontSize: "14px",
      marginRight: "8px"
    },
    searchButton: {
      padding: "8px 12px",
      backgroundColor: "#3b82f6",
      color: "#ffffff",
      border: "none",
      borderRadius: "6px",
      fontSize: "12px",
      cursor: "pointer"
    },
    resultTable: {
      width: "100%",
      borderCollapse: "collapse",
      fontSize: "12px"
    },
    resultTh: {
      padding: "8px 12px",
      backgroundColor: "#f1f5f9",
      borderBottom: "1px solid #e2e8f0",
      fontSize: "11px",
      fontWeight: "600",
      color: "#374151",
      textAlign: "left"
    },
    resultTd: {
      padding: "8px 12px",
      borderBottom: "1px solid #f1f5f9",
      verticalAlign: "top"
    },
    productItem: {
      cursor: "pointer",
      padding: "2px 4px",
      borderRadius: "4px",
      transition: "background-color 0.2s ease",
      display: "inline-block",
      margin: "2px"
    },
    productItemHover: {
      backgroundColor: "#eff6ff",
      color: "#3b82f6"
    },
    fileUploadGroup: {
      marginBottom: "16px"
    },
    fileUploadHeader: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      marginBottom: "8px"
    },
    fileUploadInput: {
      width: "100%",
      padding: "8px 12px",
      border: "1px solid #d1d5db",
      borderRadius: "6px",
      fontSize: "14px",
      backgroundColor: "#f9fafb",
      color: "#6b7280"
    },
    productListItem: {
      position: "relative",
      padding: "16px",
      backgroundColor: "#f8fafc",
      borderRadius: "8px",
      marginBottom: "12px",
      border: "1px solid #e2e8f0"
    },
    removeButton: {
      position: "absolute",
      right: "8px",
      top: "8px",
      background: "transparent",
      border: "none",
      color: "#dc2626",
      cursor: "pointer",
      fontSize: "16px",
      padding: "4px",
      borderRadius: "4px",
      transition: "background-color 0.2s ease"
    },
    buttonList: {
      padding: "16px 20px",
      borderTop: "1px solid #e2e8f0",
      backgroundColor: "#f8fafc",
      display: "flex",
      flexDirection: "column",
      gap: "8px"
    },
    statusIndicator: {
      display: "inline-flex",
      alignItems: "center",
      gap: "4px",
      padding: "4px 8px",
      borderRadius: "4px",
      fontSize: "12px",
      fontWeight: "500"
    },
    statusSuccess: {
      backgroundColor: "#dcfce7",
      color: "#166534"
    },
    statusError: {
      backgroundColor: "#fef2f2",
      color: "#991b1b"
    },
    categoryHeader: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      cursor: "pointer",
      padding: "8px",
      backgroundColor: "#f1f5f9",
      borderRadius: "4px",
      marginBottom: "4px"
    }
  };

  // useEffect 훅들
  useEffect(() => {
    if (alreadyApplicantName) {
      setApplicantName(alreadyApplicantName);
    }
  }, [alreadyApplicantName]);

  useEffect(() => {
    if (customerNumber) {
      setPatentCustomerNumber(customerNumber);
    }
  }, [customerNumber]);

  useEffect(() => {
    if (markNameArr?.length) {
      setMarkName(markNameArr.join(" "));
    }
  }, [markNameArr]);

  useEffect(() => {
    if (selectedCategory && categoryData[selectedCategory]) {
      const groupKeys = Object.keys(categoryData[selectedCategory]);
      const openState = {};
      groupKeys.forEach((key) => {
        openState[key] = true;
      });
      setOpenGroups(openState);
    }
  }, [categoryData, selectedCategory]);

  useEffect(() => {
    const el = resultWrapRef.current;
    if (!el || !hasMore || isLoading) return;

    if (el.scrollHeight <= el.clientHeight) {
      setIsLoading(true);
      loadCategoryData(selectedCategory, searchKeyword, true).finally(() => {
        setIsLoading(false);
      });
    }
  }, [categoryData, selectedCategory, hasMore]);

  // 유틸리티 함수들
  const normalizeSearchResult = (dataArray) => {
    const result = {};
    dataArray.forEach((group) => {
      const code = group.similar_code;
      const items = group.products;

      if (code && Array.isArray(items)) {
        result[code] = items;
      }
    });
    return result;
  };

  const addProductList = () => {
    setSearchKeyword("");
    setProductList([...productList, { category: "", items: "" }]);
  };

  const handleProductChange = (index, field, value) => {
    setSearchKeyword("");
    const updated = [...productList];
    updated[index][field] = value;
    setProductList(updated);

    if (field === "category") {
      const numericCategory = value.replace("류", "").padStart(2, "0");
      setSelectedCategory(numericCategory);
      setFocusedProductIndex(index);
      loadCategoryData(numericCategory);
    }
  };

  const handleAddItemToTextarea = (index, itemToAdd) => {
    setProductList((prev) => {
      const updated = [...prev];
      const currentItems = updated[index].items;
      const itemList = currentItems.split(",").map((item) => item.trim());

      if (!itemList.includes(itemToAdd)) {
        updated[index].items = currentItems
          ? `${currentItems}, ${itemToAdd}`
          : itemToAdd;
      }

      return updated;
    });
  };

  const handleRemoveProduct = (index) => {
    setProductList((prev) => prev.filter((_, i) => i !== index));
  };

  const toggleGroupOpen = (groupKey) => {
    setOpenGroups((prev) => ({
      ...prev,
      [groupKey]: !prev[groupKey],
    }));
  };

  // API 호출 함수들
  const checkUserId = async () => {
    if (!userId.trim()) return;

    try {
      const res = await getIdExists(userId.trim());
      setIdChecked(true);
      if (res.status === 200) {
        setIdExists(true);
      } else {
        setIdExists(false);
      }
    } catch (err) {
      console.error("아이디 확인 중 오류:", err);
      setIdExists(false);
      setIdChecked(true);
    }
  };

  const loadCategoryData = async (category, keyword = "", isLoadMore = false) => {
    const key = `${category}_${keyword}`;
    const currentOffset = isLoadMore ? offsets[key] || 0 : 0;

    try {
      const res = await searchCategoryDetail(currentOffset, limit, category, keyword);
      const raw = res?.data?.data || [];
      const normalized = normalizeSearchResult(raw);

      setCategoryData((prev) => ({
        ...prev,
        [category]: isLoadMore
          ? { ...prev[category], ...normalized }
          : normalized,
      }));

      if (raw.length === 0 || Object.keys(normalized).length === 0) {
        setHasMore(false);
      } else {
        setHasMore(true);
        setOffsets((prev) => ({
          ...prev,
          [key]: currentOffset + limit,
        }));
      }
    } catch (err) {
      console.error("유사군 데이터 불러오기 실패:", err);
      alert("유사군 항목을 불러오는 중 오류가 발생했습니다.");
    }
  };

  const handleSearch = () => {
    if (!selectedCategory) {
      alert("먼저 상품분류(류)를 선택해 주세요.");
      return;
    }
    loadCategoryData(selectedCategory, searchKeyword);
  };

  const handleScroll = () => {
    const el = resultWrapRef.current;
    if (!el || isLoading || !hasMore) return;

    const { scrollTop, scrollHeight, clientHeight } = el;
    if (scrollTop + clientHeight >= scrollHeight - 50) {
      setIsLoading(true);
      loadCategoryData(selectedCategory, searchKeyword, true).finally(() => {
        setIsLoading(false);
      });
    }
  };

  // 이미지 업로드 함수
  const imgPreview = async (e) => {
    for (let file of e.target.files) {
      setOriginalFileName(file.name);
      setFile(file);

      const reader = new FileReader();
      reader.onload = async () => {
        setImg(reader.result);
        setUploadImg(reader.result);

        const formData = new FormData();
        formData.append("files", file, file.name);
        formData.append("file_type", "logo_agent");

        try {
          const result = await getUploadFile(formData);
          if (typeof result === "object") {
            const originalFileName = result?.data[0]?.original_file_name;
            const fileName = result?.data[0]?.filename;
            const path = result?.data[0]?.path;

            setOriginalFileName(originalFileName);
            setFileName(fileName);
            setImagePath(path);
            setUploadComplete(true);
          } else {
            setUploadComplete(false);
          }
        } catch (error) {
          console.error("원본 이미지 업로드 실패:", error);
          setUploadComplete(false);
        }
      };
      reader.readAsDataURL(file);
    }
  };

  // 파일 업로드 함수
  const uploadSupportingFile = async (applicationId, type, file) => {
    if (!file) {
      console.error("❌ 업로드할 파일이 없습니다!", { applicationId, type });
      return;
    }

    const formData = new FormData();
    formData.append("file_type", type);
    formData.append("file", file);
    await getApplicationUploadFile(applicationId, formData);
  };

  // BIB 파일 처리 함수
  const handleBibFileUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file || !file.name.toLowerCase().endsWith(".bib")) {
      alert("BIB 파일만 업로드 가능합니다.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await parseBibData(formData);

      if (response.data) {
        if (response.data.applicationdate) {
          const dateString = response.data.applicationdate;
          const formattedDate = `${dateString.slice(0, 4)}-${dateString.slice(4, 6)}-${dateString.slice(6, 8)}`;
          setApplicationDate(formattedDate);
        }
        
        if (response.data.applicant && response.data.applicant.applicant_name) {
          setApplicantName(response.data.applicant.applicant_name);
        }

        if (response.data.applicant && response.data.applicant.patent_customer_number) {
          setPatentCustomerNumber(response.data.applicant.patent_customer_number);
        }

        if (response.data.products && response.data.products.mark_class) {
          const formattedMarkClass = response.data.products.mark_class.replace(/^제/, "");
          handleProductChange(0, "category", formattedMarkClass);
        }

        if (response.data.products.product_names && response.data.products.product_names.length > 0) {
          const productsString = response.data.products.product_names
            .map((name) => name.replace(/[\r\n\s]+/g, " ").trim())
            .join(", ");
          handleProductChange(0, "items", productsString);
        }
      }
    } catch (error) {
      console.error("BIB 파일 처리 중 오류:", error);
      alert("BIB 파일 처리 중 오류가 발생했습니다.");
    }
  };

  // 폼 제출 함수
  const handleSubmit = async () => {
    if (!pkUserId) {
      if (!idChecked) {
        alert("아이디 확인을 먼저 해주세요.");
        return;
      }

      if (!idExists) {
        alert("존재하지 않는 아이디입니다. 다시 입력해주세요.");
        return;
      }
    }

    const rawApplicationNumber = applicationNumber.replaceAll("-", "");
    const rawCustomerNumber = patentCustomerNumber.replaceAll("-", "");

    if (rawApplicationNumber.length !== 13) {
      alert("출원번호는 13자리여야 합니다.");
      return;
    }

    if (rawCustomerNumber.length !== 12) {
      alert("특허고객번호는 12자리여야 합니다.");
      return;
    }

    if (!rawApplicationNumber || !applicationDate || !applicantName.trim() || !priorityReview) {
      alert("모두 입력해주세요.");
      return;
    }

    const validProducts = productList.filter((item) => item.category && item.items.trim());

    if (validProducts.length === 0) {
      alert("상품 분류 및 등록상품은 최소 1개 이상 입력해야 합니다.");
      return;
    }

    if (applicationType === "") {
      alert("출원 유형을 선택해주세요.");
      return;
    }

    const payload = {
      user_id: pkUserId || userId,
      application_number: rawApplicationNumber,
      application_date: applicationDate,
      applicant_name: applicantName,
      status: applicationStatus,
      internal_status: null,
      patent_customer_number: rawCustomerNumber,
      mark_name: markName,
      image_original_filename: originalFileName,
      image_filename: fileName,
      image_path: imagePath,
      products: productList
        .filter((item) => item.category && item.items.trim())
        .map((item) => ({
          mark_class: item.category.replace("류", "").padStart(2, "0"),
          product_name: item.items
            .split(",")
            .map((p) => p.trim())
            .filter((p) => p),
        })),
      apply_type: applicationType,
      priority_review_yn: priorityReview
    };

    try {
      const res = await addApplicationNumber(payload);
      const applicationId = res?.data?.application_info_id;
      if (!applicationId) throw new Error("application_info_id 없음");

      try {
        if (fileRefApplication.current?.files?.[0]) {
          await uploadSupportingFile(applicationId, "application", fileRefApplication.current.files[0]);
        }
        if (fileRefPower.current?.files?.[0]) {
          await uploadSupportingFile(applicationId, "attorney", fileRefPower.current.files[0]);
        }
        if (fileRefSeal.current?.files?.[0]) {
          await uploadSupportingFile(applicationId, "stamp", fileRefSeal.current.files[0]);
        }
      } catch (uploadErr) {
        console.error("파일 업로드 실패:", uploadErr);
        alert("파일 업로드 중 오류가 발생했습니다.");
        return;
      }

      alert("등록이 완료되었습니다");
      setEnterFloatSideBar(false);
      if (!pkUserId) {
        getList();
      }
    } catch (err) {
      console.error("등록 실패:", err);
      if (err?.response?.status === 422) {
        alert("모든 필수 항목을 입력해 주세요.");
      } else {
        alert("등록 중 오류가 발생했습니다.");
      }
    }
  };

  const selectedCategories = productList.map((p) => p.category).filter(Boolean);

  return (
    <div style={styles.container}>
      {/* 왼쪽 섹션 - 상품 검색 */}
      {isOpen && (
        <div style={styles.leftSection}>
          <div style={styles.sectionHeader}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <FaSearch />
              <span>{selectedCategory}류 상품 검색</span>
            </div>
            <button
              style={styles.headerButton}
              onClick={() => setIsOpen(false)}
              onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(255,255,255,0.1)'}
              onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
            >
              <FaChevronRight />
            </button>
          </div>

          {/* 검색 영역 */}
          <div style={styles.searchSection}>
            <div style={{ display: 'flex', marginBottom: '8px' }}>
              <input
                type="text"
                style={styles.searchInput}
                value={searchKeyword}
                onChange={(e) => setSearchKeyword(e.target.value)}
                placeholder="항목 검색"
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleSearch();
                  }
                }}
              />
              <button
                style={styles.searchButton}
                onClick={handleSearch}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#2563eb'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#3b82f6'}
              >
                <FaSearch />
              </button>
            </div>
            <button
              style={{...styles.button, ...styles.buttonSecondary, width: '100%'}}
              onClick={() => {
                setSearchKeyword("");
                loadCategoryData(selectedCategory);
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#4b5563'}
              onMouseLeave={(e) => e.target.style.backgroundColor = '#6b7280'}
            >
              <FaTimes />
              초기화
            </button>
          </div>

          {/* 검색 결과 */}
          <div
            style={{ flex: 1, overflow: 'auto' }}
            ref={resultWrapRef}
            onScroll={handleScroll}
          >
            <table style={styles.resultTable}>
              <thead>
                <tr>
                  <th style={{...styles.resultTh, width: '80px'}}>유사군</th>
                  <th style={{...styles.resultTh, width: '300px'}}>세부항목</th>
                </tr>
              </thead>
              <tbody>
                {Object.entries(categoryData[selectedCategory] || {}).map(
                  ([groupCodes, items]) => {
                    const isGroupOpen = openGroups[groupCodes];

                    return (
                      <tr key={groupCodes}>
                        <td
                          style={{
                            ...styles.resultTd,
                            cursor: 'pointer',
                            backgroundColor: '#f8fafc'
                          }}
                          onClick={() => toggleGroupOpen(groupCodes)}
                        >
                          <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            cursor: 'pointer',
                            padding: '4px',
                            backgroundColor: '#f1f5f9',
                            borderRadius: '4px'
                          }}>
                            <div>
                              {groupCodes.split(",").map((code) => (
                                <div key={code} style={{ fontSize: '11px', fontWeight: '600' }}>
                                  {code}
                                </div>
                              ))}
                            </div>
                            {isGroupOpen ? <FaChevronUp size={10} /> : <FaChevronDown size={10} />}
                          </div>
                        </td>

                        <td style={styles.resultTd}>
                          {isGroupOpen &&
                            items.map((item, idx) => (
                              <span
                                key={idx}
                                style={styles.productItem}
                                onClick={() => {
                                  if (focusedProductIndex !== -1) {
                                    handleAddItemToTextarea(focusedProductIndex, item);
                                  } else {
                                    alert("등록상품을 먼저 선택해 주세요.");
                                  }
                                }}
                                onMouseEnter={(e) => {
                                  e.target.style.backgroundColor = '#eff6ff';
                                  e.target.style.color = '#3b82f6';
                                }}
                                onMouseLeave={(e) => {
                                  e.target.style.backgroundColor = 'transparent';
                                  e.target.style.color = 'inherit';
                                }}
                              >
                                {item}
                                {idx < items.length - 1 ? ", " : ""}
                              </span>
                            ))}
                        </td>
                      </tr>
                    );
                  }
                )}
              </tbody>
            </table>
            {isLoading && (
              <div style={{ textAlign: 'center', padding: '16px', color: '#6b7280' }}>
                로딩 중...
              </div>
            )}
          </div>
        </div>
      )}

      {/* 오른쪽 섹션 - 폼 */}
      <div style={styles.rightSection}>
        <div style={styles.sectionHeader}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            {!isOpen && (
              <button
                style={styles.headerButton}
                onClick={() => setIsOpen(true)}
                onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(255,255,255,0.1)'}
                onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
              >
                <FaChevronLeft />
              </button>
            )}
            <FaFileAlt />
            <span>출원 정보 등록</span>
          </div>
          <button
            style={styles.headerButton}
            onClick={() => setEnterFloatSideBar(false)}
            onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(255,255,255,0.1)'}
            onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
          >
            <IoCloseOutline size={20} />
          </button>
        </div>

        <div style={styles.content}>
          {/* 이미지 업로드 */}
          <div style={styles.inputGroup}>
            <label style={styles.label}>
              <FaImage style={{ marginRight: '4px' }} />
              상표 이미지
            </label>
            <div
              style={styles.imageUpload}
              onClick={() => fileInputRef.current?.click()}
              onMouseEnter={(e) => {
                e.target.style.borderColor = '#3b82f6';
                e.target.style.backgroundColor = '#eff6ff';
              }}
              onMouseLeave={(e) => {
                e.target.style.borderColor = '#cbd5e1';
                e.target.style.backgroundColor = '#f8fafc';
              }}
            >
              <input
                type="file"
                onChange={imgPreview}
                accept="image/*"
                style={{ display: "none" }}
                ref={fileInputRef}
              />

              {img ? (
                <img
                  style={styles.uploadedImage}
                  src={img}
                  alt="업로드된 이미지"
                />
              ) : (
                <div style={{ textAlign: 'center', color: '#6b7280' }}>
                  <FaImages size={32} style={{ marginBottom: '8px' }} />
                  <div>이미지를 업로드해 주세요.</div>
                </div>
              )}
            </div>
            
            {uploadImg && (
              <button
                style={{...styles.button, ...styles.buttonDanger, width: '100%'}}
                onClick={() => {
                  setUploadImg("");
                  setOriginalFileName("");
                  setFileName("");
                  setImagePath("");
                  setFile(null);
                  setImg("");
                  setUploadComplete(false);
                  if (fileInputRef.current) {
                    fileInputRef.current.value = "";
                  }
                }}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#b91c1c'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#dc2626'}
              >
                <FaTrash />
                이미지 삭제
              </button>
            )}
          </div>

          {/* 사용자 ID */}
          {!pkUserId && (
            <div style={styles.inputGroup}>
              <label style={styles.label}>
                <FaUser style={{ marginRight: '4px' }} />
                사용자 ID
              </label>
              <div style={{ display: 'flex', gap: '8px' }}>
                <input
                  type="text"
                  style={{ ...styles.input, flex: 1 }}
                  value={userId}
                  onChange={(e) => setUserId(e.target.value)}
                  placeholder="아이디 입력"
                />
                <button
                  style={styles.button}
                  onClick={checkUserId}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#2563eb'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = '#3b82f6'}
                >
                  <FaCheck />
                  확인
                </button>
              </div>
              
              {idExists === false && (
                <div style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '4px',
                  padding: '4px 8px',
                  borderRadius: '4px',
                  fontSize: '12px',
                  fontWeight: '500',
                  backgroundColor: '#fef2f2',
                  color: '#991b1b',
                  marginTop: '4px'
                }}>
                  <FaTimes />
                  등록되지 않은 사용자입니다.
                </div>
              )}
              {idExists === true && (
                <div style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '4px',
                  padding: '4px 8px',
                  borderRadius: '4px',
                  fontSize: '12px',
                  fontWeight: '500',
                  backgroundColor: '#dcfce7',
                  color: '#166534',
                  marginTop: '4px'
                }}>
                  <FaCheck />
                  등록된 사용자입니다.
                </div>
              )}
            </div>
          )}

          {/* 상표명 */}
          <div style={styles.inputGroup}>
            <label style={styles.label}>
              <FaTags style={{ marginRight: '4px' }} />
              상표명
            </label>
            <input
              type="text"
              style={styles.input}
              value={markName}
              onChange={(e) => setMarkName(e.target.value)}
              placeholder="상표명을 입력하세요"
            />
          </div>

          {/* 출원번호 */}
          <div style={styles.inputGroup}>
            <label style={styles.label}>
              <FaFileAlt style={{ marginRight: '4px' }} />
              출원번호
            </label>
            <input
              type="text"
              style={styles.input}
              placeholder="예: 45-2023-0004053"
              value={applicationNumber}
              onChange={(e) => {
                const input = e.target.value.replace(/\D/g, "");
                let formatted = input;
                if (input.length > 2 && input.length <= 6) {
                  formatted = `${input.slice(0, 2)}-${input.slice(2)}`;
                } else if (input.length > 6) {
                  formatted = `${input.slice(0, 2)}-${input.slice(2, 6)}-${input.slice(6, 13)}`;
                }
                setApplicationNumber(formatted);
              }}
            />
          </div>

          {/* 출원일자 */}
          <div style={styles.inputGroup}>
            <label style={styles.label}>
              <FaCalendarAlt style={{ marginRight: '4px' }} />
              출원일자
            </label>
            <input
              type="date"
              style={styles.input}
              value={applicationDate}
              onChange={(e) => setApplicationDate(e.target.value)}
            />
          </div>

          {/* 출원인 */}
          <div style={styles.inputGroup}>
            <label style={styles.label}>
              <FaUser style={{ marginRight: '4px' }} />
              출원인
            </label>
            <input
              type="text"
              style={styles.input}
              value={applicantName}
              onChange={(e) => setApplicantName(e.target.value)}
              placeholder="출원인명을 입력하세요"
            />
          </div>

          {/* 특허고객번호 */}
          <div style={styles.inputGroup}>
            <label style={styles.label}>
              <FaReceipt style={{ marginRight: '4px' }} />
              특허고객번호
            </label>
            <input
              type="text"
              style={styles.input}
              value={patentCustomerNumber}
              onChange={(e) => {
                const input = e.target.value.replace(/\D/g, "");
                let formatted = input;

                if (input.length > 1 && input.length <= 5) {
                  formatted = `${input.slice(0, 1)}-${input.slice(1)}`;
                } else if (input.length > 5 && input.length <= 11) {
                  formatted = `${input.slice(0, 1)}-${input.slice(1, 5)}-${input.slice(5)}`;
                } else if (input.length > 11) {
                  formatted = `${input.slice(0, 1)}-${input.slice(1, 5)}-${input.slice(5, 11)}-${input.slice(11, 12)}`;
                }

                setPatentCustomerNumber(formatted);
              }}
              placeholder="예: 1-1111-111111-1"
            />
          </div>

          {/* 파일 첨부 섹션들 */}
          {/* 출원서 첨부 */}
          <div style={styles.fileUploadGroup}>
            <div style={styles.fileUploadHeader}>
              <label style={styles.label}>
                <FaUpload style={{ marginRight: '4px' }} />
                출원서 첨부
              </label>
              <div style={{ display: 'flex', gap: '4px' }}>
                <button
                  style={{...styles.button, ...styles.buttonSmall}}
                  onClick={() => fileRefApplication.current?.click()}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#2563eb'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = '#3b82f6'}
                >
                  <FaUpload />
                  첨부
                </button>
                {fileNameApplication && (
                  <button
                    style={{...styles.button, ...styles.buttonDanger, ...styles.buttonSmall}}
                    onClick={() => {
                      setFileNameApplication("");
                      fileRefApplication.current.value = "";
                    }}
                    onMouseEnter={(e) => e.target.style.backgroundColor = '#b91c1c'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = '#dc2626'}
                  >
                    <FaTrash />
                  </button>
                )}
              </div>
            </div>
            <input
              type="text"
              style={styles.fileUploadInput}
              value={fileNameApplication}
              readOnly
              placeholder="첨부된 파일 없음"
            />
            <input
              type="file"
              ref={fileRefApplication}
              style={{ display: "none" }}
              onChange={(e) => {
                const file = e.target.files?.[0];
                if (file) setFileNameApplication(file.name);
              }}
            />
          </div>

          {/* 위임장 첨부 */}
          <div style={styles.fileUploadGroup}>
            <div style={styles.fileUploadHeader}>
              <label style={styles.label}>
                <FaUpload style={{ marginRight: '4px' }} />
                위임장 첨부
              </label>
              <div style={{ display: 'flex', gap: '4px' }}>
                <button
                  style={{...styles.button, ...styles.buttonSmall}}
                  onClick={() => fileRefPower.current?.click()}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#2563eb'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = '#3b82f6'}
                >
                  <FaUpload />
                  첨부
                </button>
                {fileNamePower && (
                  <button
                    style={{...styles.button, ...styles.buttonDanger, ...styles.buttonSmall}}
                    onClick={() => {
                      setFileNamePower("");
                      fileRefPower.current.value = "";
                    }}
                    onMouseEnter={(e) => e.target.style.backgroundColor = '#b91c1c'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = '#dc2626'}
                  >
                    <FaTrash />
                  </button>
                )}
              </div>
            </div>
            <input
              type="text"
              style={styles.fileUploadInput}
              value={fileNamePower}
              readOnly
              placeholder="첨부된 파일 없음"
            />
            <input
              type="file"
              ref={fileRefPower}
              style={{ display: "none" }}
              onChange={(e) => {
                const file = e.target.files?.[0];
                if (file) setFileNamePower(file.name);
              }}
            />
          </div>

          {/* 도장 첨부 */}
          <div style={styles.fileUploadGroup}>
            <div style={styles.fileUploadHeader}>
              <label style={styles.label}>
                <FaUpload style={{ marginRight: '4px' }} />
                도장 첨부
              </label>
              <div style={{ display: 'flex', gap: '4px' }}>
                <button
                  style={{...styles.button, ...styles.buttonSmall}}
                  onClick={() => fileRefSeal.current?.click()}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#2563eb'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = '#3b82f6'}
                >
                  <FaUpload />
                  첨부
                </button>
                {fileNameSeal && (
                  <button
                    style={{...styles.button, ...styles.buttonDanger, ...styles.buttonSmall}}
                    onClick={() => {
                      setFileNameSeal("");
                      fileRefSeal.current.value = "";
                    }}
                    onMouseEnter={(e) => e.target.style.backgroundColor = '#b91c1c'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = '#dc2626'}
                  >
                    <FaTrash />
                  </button>
                )}
              </div>
            </div>
            <input
              type="text"
              style={styles.fileUploadInput}
              value={fileNameSeal}
              readOnly
              placeholder="첨부된 파일 없음"
            />
            <input
              type="file"
              ref={fileRefSeal}
              style={{ display: "none" }}
              onChange={(e) => {
                const file = e.target.files?.[0];
                if (file) setFileNameSeal(file.name);
              }}
            />
          </div>

          {/* 출원 유형 */}
          <div style={styles.inputGroup}>
            <label style={styles.label}>
              <FaFileAlt style={{ marginRight: '4px' }} />
              출원 유형
            </label>
            <select
              style={styles.select}
              value={applicationType}
              onChange={(e) => setApplicationType(e.target.value)}
            >
              <option value="">선택</option>
              {applicationTypes.map((type) => (
                <option key={type.value} value={type.value}>
                  {type.label}
                </option>
              ))}
            </select>
          </div>

          {/* 출원 상태 */}
          <div style={styles.inputGroup}>
            <label style={styles.label}>
              <FaCheck style={{ marginRight: '4px' }} />
              출원 상태
            </label>
            <select
              style={styles.select}
              value={applicationStatus}
              onChange={(e) => setApplicationStatus(e.target.value)}
            >
              <option value="">선택</option>
              {applicationStatuses.map((status) => (
                <option key={status.value} value={status.value}>
                  {status.label}
                </option>
              ))}
            </select>
          </div>

          {/* 우선심사 여부 */}
          <div style={styles.inputGroup}>
            <label style={styles.label}>
              <FaCheck style={{ marginRight: '4px' }} />
              우선심사 여부
            </label>
            <select
              style={styles.select}
              value={priorityReview}
              onChange={(e) => setPriorityReveiw(e.target.value)}
            >
              <option value="">선택</option>
              {priorityOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          {/* 상품 목록 */}
          <div style={styles.inputGroup}>
            <label style={styles.label}>
              <FaListAlt style={{ marginRight: '4px' }} />
              상품 분류
            </label>
            
            {productList.map((item, idx) => (
              <div key={idx} style={styles.productListItem}>
                <button
                  style={styles.removeButton}
                  onClick={() => handleRemoveProduct(idx)}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#fef2f2'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                  title="삭제"
                >
                  <FaTimes />
                </button>

                <div style={{ marginBottom: '12px' }}>
                  <label style={{...styles.label, marginBottom: '4px'}}>상품분류</label>
                  <select
                    style={styles.select}
                    value={item.category}
                    onChange={(e) => handleProductChange(idx, "category", e.target.value)}
                    disabled={item.items.trim() !== ""}
                  >
                    <option value="">선택</option>
                    {Array.from({ length: 45 }, (_, i) => {
                      const categoryValue = `${i + 1}류`;
                      const isSelected = selectedCategories.includes(categoryValue) && item.category !== categoryValue;
                      return (
                        <option
                          key={categoryValue}
                          value={categoryValue}
                          disabled={isSelected}
                        >
                          {categoryValue}
                        </option>
                      );
                    })}
                  </select>
                </div>

                <div>
                  <label style={{...styles.label, marginBottom: '4px'}}>
                    등록상품 ({item.items ? item.items.split(",").map((i) => i.trim()).filter(Boolean).length : 0})
                  </label>
                  <textarea
                    style={styles.textarea}
                    value={item.items}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                      }
                    }}
                    onFocus={() => {
                      setSearchKeyword("");
                      setFocusedProductIndex(idx);

                      const category = item.category;
                      if (category) {
                        const numericCategory = category.replace("류", "").padStart(2, "0");
                        setSelectedCategory(numericCategory);
                        loadCategoryData(numericCategory);
                      }
                    }}
                    onChange={(e) => handleProductChange(idx, "items", e.target.value)}
                    placeholder="등록할 상품을 입력하세요 (쉼표로 구분)"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 버튼 영역 */}
        <div style={{
          padding: "16px 20px",
          borderTop: "1px solid #e2e8f0",
          backgroundColor: "#f8fafc",
          display: "flex",
          flexDirection: "column",
          gap: "8px"
        }}>
          <button
            style={{...styles.button, ...styles.buttonSecondary}}
            onClick={addProductList}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#4b5563'}
            onMouseLeave={(e) => e.target.style.backgroundColor = '#6b7280'}
          >
            <FiPlusCircle />
            상품분류 추가
          </button>
          
          <button
            style={{...styles.button, ...styles.buttonSuccess}}
            onClick={handleSubmit}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#047857'}
            onMouseLeave={(e) => e.target.style.backgroundColor = '#059669'}
          >
            <FaSave />
            등록
          </button>
          
          <button
            style={styles.button}
            onClick={() => bibFileInputRef.current?.click()}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#2563eb'}
            onMouseLeave={(e) => e.target.style.backgroundColor = '#3b82f6'}
          >
            <FaUpload />
            BIB 파일 불러오기
          </button>
          
          <input
            type="file"
            ref={bibFileInputRef}
            style={{ display: "none" }}
            accept=".bib"
            onChange={handleBibFileUpload}
          />
        </div>
      </div>
    </div>
  );
};

export default ApplicationForm;